<ngb-pagination *ngIf="collectionSize > pageSize" 
  [collectionSize]="collectionSize"
  [(page)]="page"
  [pageSize]="pageSize"
  [maxSize]="maxSize"
  [rotate]="true"
  (pageChange)="onPageChange($event)"
  aria-label="Default pagination"></ngb-pagination>
